import { DownOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { css } from '@emotion/react';
import { Avatar, Dropdown, Space } from 'antd';
import { useNavigate } from 'react-router-dom';

import Flex from '~/common/components/display/Flex.tsx';
import useLayout from '~/common/hooks/useLayout.ts';
import { safeArea } from '~/common/utils/safe-area.utils';
import { ADMIN_ROLE_LABELS } from '~/features/admin/data/admin.data';
import useAuth from '~/features/auth/hooks/useAuth';

import type { MenuProps } from 'antd';

import type { AdminRole } from '~/features/admin/types/admin.type';

/** 역할 표시 텍스트 */
const getRoleLabel = (role: AdminRole) => {
  return ADMIN_ROLE_LABELS[role]?.label || '관리자';
};

function ProfileMenu() {
  const navigate = useNavigate();
  const { handleToggleSidebar } = useLayout();
  const { state: authState, handleSignOut } = useAuth();
  const { authUser } = authState;

  const handleNavigate = (path: string) => {
    navigate(path);
    if (window.innerWidth < 768) {
      handleToggleSidebar();
    }
  };

  const profileMenuItems: MenuProps['items'] = [
    {
      key: 'mypage',
      label: '마이페이지',
      icon: <UserOutlined />,
      onClick: () => handleNavigate('/mypage'),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: '로그아웃',
      icon: <LogoutOutlined />,
      danger: true,
      onClick: handleSignOut,
    },
  ];

  return (
    <div css={styles.profileWrapper}>
      <Dropdown menu={{ items: profileMenuItems }} placement="top" trigger={['click']}>
        <div css={styles.profileCard}>
          <Space size={10}>
            <Avatar shape="circle" size={36} style={{ backgroundColor: '#6c5dd3' }}>
              {authUser?.userId?.charAt(0).toUpperCase() ?? 'A'}
            </Avatar>
            <Flex direction="column" gap={0} justify="center">
              <span css={styles.userName}>{authUser?.userId ?? '관리자'}</span>
              <span css={styles.userRole}>{authUser ? getRoleLabel(authUser.role) : '-'}</span>
            </Flex>
          </Space>
          <DownOutlined style={{ fontSize: '10px', color: '#7e8299' }} />
        </div>
      </Dropdown>
    </div>
  );
}

const styles = {
  profileWrapper: css`
    padding: 12px;
    ${safeArea('bottom')}
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    z-index: 1;
    background: rgba(10, 12, 24, 0.5);
  `,

  profileCard: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s;
    color: #fff;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
  `,

  userName: css`
    font-size: 13px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.2;
  `,

  userRole: css`
    font-size: 11px;
    color: rgba(255, 255, 255, 0.5);
    line-height: 1.2;
  `,
};

export default ProfileMenu;
